// extracted by mini-css-extract-plugin
export default {"root":"PageBackground-root","ev":"PageBackground-ev"};